<footer>
    <svg viewBox="0 0 120 16">
        <defs>
            <path id="wave"
                d="M 0,10 C 30,10 30,15 60,15 90,15 90,10 120,10 150,10 150,15 180,15 210,15 210,10 240,10 v 28 h -240 z" />
        </defs>
        <use id="wave3" class="wave" xlink:href="#wave" x="0" y="-2"></use>
        <use id="wave2" class="wave" xlink:href="#wave" x="0" y="0"></use>
    </svg>
        <div class="flex flex-row items-end absolute bottom-0 left-0">
            <a href="https://x.com/Fusilli_project">
                <img class="twitter mx-1 h-8" src="../assets/img/twitter.png">
            </a>
            <a href="https://linkedin.com/company/fusilli-project">
                <img class="in mx-1 h-8" src="../assets/img/linkedin.png">
            </a>
        </div>
        <div class="flex flex-col justify-center items-center">
            <img src="../../../assets/img/qr.png" class="object-scale-down w-14 rounded-lg">
            <a href="https://fusilli-project.eu/" class="text-xl text-green-900 hover:underline">
                FUSILLI website
            </a>
        </div>
        <div class="flex justify-end mx-16">
            <p class="text-green-900 cursor-default text-xs">
                This project has received funding from the European Union’s Horizon 2020 <br>
                research and innovation programme under grant agreement No. 101000717.
            </p>
            <img src="../../../assets/img/flag.jpg" class="absolute bottom-0 right-0 mr-1 object-scale-down w-10">
        </div>
</footer>